import axios from 'axios';

// Determine Base API URL with environment variable & runtime config support
const getApiBaseUrl = () => {
  // 1. Dynamic Runtime Config from build/config.js (allows changing URL without rebuilding)
  if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.API_URL) {
    return window.__RUNTIME_CONFIG__.API_URL;
  }
  // 2. Build-time .env / .env.production / .env.development
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // 3. Fallback: in production relative '/api', in development 'http://localhost:5000/api'
  return process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';
};

const axiosClient = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request Interceptor: Attach JWT Token & Active Firm/Year headers
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('fish_shop_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const firmId = localStorage.getItem('fish_shop_firm_id');
    if (firmId) {
      config.headers['x-firm-id'] = firmId;
    }
    const fid = localStorage.getItem('fish_shop_fid');
    if (fid) {
      config.headers['x-fid'] = fid;
    }

    // Pass the browser's active subdomain/domain to the backend for automatic database coordination
    if (typeof window !== 'undefined' && window.location && window.location.hostname) {
      config.headers['x-tenant-domain'] = window.location.hostname;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: Handle 401 Unauthorized
axiosClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear token and redirect to login if not already there
      if (!window.location.pathname.includes('/login')) {
        localStorage.removeItem('fish_shop_token');
        localStorage.removeItem('fish_shop_user');
        window.location.href = '/login';
      }
    }
    const message = error.response?.data?.message || error.message || 'An error occurred';
    return Promise.reject(new Error(message));
  }
);

export default axiosClient;
